<template>
        <a v-on:click="countryListModel()" >
            <i class="fa fa-globe"></i> Australia
        </a>
</template>

<script>
import Vue from 'vue';
import WwfCountryList from './WwfCountryList';

export default {
    components: { WwfCountryList },
    name: "wwf-menu-country-list-btn",

    methods: {
        countryListModel:function(){
            var ComponentClass = Vue.extend(WwfCountryList);
            var instance = new ComponentClass();
            instance.$mount();   
            var vueContainer = document.getElementById('country');
        
            // if DOM is not there create it
            if(!vueContainer.children[1])
                vueContainer.appendChild(instance.$el);

        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// WwfMenuCountryListBtn.vue?077d4b91